import { render, staticRenderFns } from "./callPatientMain.vue?vue&type=template&id=9ae3a622&scoped=true&"
import script from "./callPatientMain.vue?vue&type=script&lang=js&"
export * from "./callPatientMain.vue?vue&type=script&lang=js&"
import style0 from "./callPatientMain.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./callPatientMain.vue?vue&type=style&index=1&id=9ae3a622&lang=scss&scoped=true&"
import style2 from "./callPatientMain.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae3a622",
  null
  
)

export default component.exports